import {
  POLICY_LIST_REQUEST,
  POLICY_LIST_SUCCESS,
  POLICY_LIST_FAIL,
  POLICY_STATS_REQUEST,
  POLICY_STATS_SUCCESS,
  POLICY_STATS_FAIL,
  POLICY_SEARCH_REQUEST,
  POLICY_SEARCH_SUCCESS,
  POLICY_SEARCH_FAIL,
  POLICY_SINGLE_REQUEST,
  POLICY_SINGLE_SUCCESS,
  POLICY_SINGLE_FAIL,
  POLICY_PER_CATEGORY_REQUEST,
  POLICY_PER_CATEGORY_SUCCESS,
  POLICY_PER_CATEGORY_FAIL,
} from "constants/policyConstants";
import PoliciesService from "services/policies-service";

export const getPolicyList = () => async (dispatch) => {
  try {
    dispatch({
      type: POLICY_LIST_REQUEST,
    });

    const res = await PoliciesService.getPolicies();
    console.log("🚀 ~ file: policyActions.js:23 ~ getPolicyList ~ res:", res);

    dispatch({
      type: POLICY_LIST_SUCCESS,
      payload: res.foundPolicies,
    });
  } catch (error) {
    console.log("🚀 ~ file: policyActions.js:30 ~ getPolicyList ~ error:", error);
    dispatch({
      type: POLICY_LIST_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error,
    });
  }
};

export const getPolicyStats = () => async (dispatch) => {
  try {
    dispatch({
      type: POLICY_STATS_REQUEST,
    });

    const res = await PoliciesService.getPoliciesStats();
    console.log("🚀 ~ file: policyActions.js:23 ~ getPolicyStats ~ res:", res);

    dispatch({
      type: POLICY_STATS_SUCCESS,
      payload: res.result,
    });
  } catch (error) {
    console.log("🚀 ~ file: policyActions.js:30 ~ getPolicyStats ~ error:", error);
    dispatch({
      type: POLICY_STATS_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error,
    });
  }
};

export const getSearchPolicy = (policySearchTerms) => async (dispatch) => {
  console.log(
    "🚀 ~ file: policyActions.js:65 ~ getSearchPolicy ~ policySearchTerms:",
    policySearchTerms
  );

  try {
    dispatch({
      type: POLICY_SEARCH_REQUEST,
    });

    const res = await PoliciesService.getPolicySearch(policySearchTerms);
    console.log("🚀 ~ file: policyActions.js:81 ~ getSearchPolicy ~ res:", res);

    dispatch({
      type: POLICY_SEARCH_SUCCESS,
      payload: res.foundSearchPolicy,
    });
  } catch (error) {
    console.log("🚀 ~ file: policyActions.js:87 ~ getSearchPolicy ~ error:", error);
    dispatch({
      type: POLICY_SEARCH_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error,
    });
  }
};

export const getSinglePolicy = (policyId) => async (dispatch) => {
  try {
    dispatch({
      type: POLICY_SINGLE_REQUEST,
    });

    const res = await PoliciesService.getPolicySingle(policyId);
    console.log("🚀 ~ file: policyActions.js:98 ~ getSinglePolicy ~ res:", res);

    dispatch({
      type: POLICY_SINGLE_SUCCESS,
      payload: res.foundPolicy,
    });
  } catch (error) {
    console.log("🚀 ~ file: policyActions.js:98 ~ getSinglePolicy ~ error:", error);
    dispatch({
      type: POLICY_SINGLE_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error,
    });
  }
};

export const getPolicyPerCategoryList = (categoryId) => async (dispatch) => {
  try {
    dispatch({
      type: POLICY_PER_CATEGORY_REQUEST,
    });

    const res = await PoliciesService.getPoliciesPerCategory(categoryId);
    console.log("🚀 ~ file: policyActions.js:122 ~ getPolicyPerCategoryList ~ res:", res);

    dispatch({
      type: POLICY_PER_CATEGORY_SUCCESS,
      payload: res.foundCategoryPolicies,
    });
  } catch (error) {
    console.log("🚀 ~ file: policyActions.js:128 ~ getPolicyPerCategoryList ~ error:", error);
    dispatch({
      type: POLICY_PER_CATEGORY_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error,
    });
  }
};
